import React from "react";
import PropTypes from "prop-types";
import { Modal } from "components/common/modal";
import { Button } from "components/common/button";
import styles from "components/documents/trash-multiple-documents.scss";

export const TrashMultipleDocumentsModal = ({
  isTrashMultipleDocumentsLoading,
  isTrashMultipleDocumentsVisible,
  onHideTrashMultipleDocuments,
  onTrashMultipleDocuments
}) => (
  <Modal
    isVisible={ isTrashMultipleDocumentsVisible }
    onClose={ onHideTrashMultipleDocuments }
    transitionName={ "trash-multiple-documents" }
  >
    <div>
      <h3>Send documents to trash?</h3>
      <div className={ styles.buttons }>
        <Button link onClick={ onHideTrashMultipleDocuments }>cancel</Button>
        <Button
          danger
          loading={ isTrashMultipleDocumentsLoading }
          onClick={ onTrashMultipleDocuments }
        >
          Trash
        </Button>
      </div>
    </div>
  </Modal>
);

TrashMultipleDocumentsModal.propTypes = {
  isTrashMultipleDocumentsLoading: PropTypes.bool.isRequired,
  isTrashMultipleDocumentsVisible: PropTypes.bool.isRequired,
  onHideTrashMultipleDocuments: PropTypes.func.isRequired,
  onTrashMultipleDocuments: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/documents/modals/trash-multiple-documents-modal.jsx